








import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'studentOfferInformationComp'
})
export default class extends Vue {
  @Prop({ default: '' }) private data!: any;
}
